export const setPage1Zones = (zones) => {
    return (dispatch) => {
        return dispatch({
            type: 'INITIAL_ZONES_LOADED',
            zones
        });
    }
}
